module.exports = __webpack_public_path__ + "static/media/tree.07a036f8.jpg";